import React, { useEffect, useState } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert,FlatList, Image,TouchableOpacity, SafeAreaView, ScrollView  } from 'react-native'
import { useNavigation } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';
import * as FileSystem from 'expo-file-system';
import Modal from "react-native-modal";



//My components 
import GeneratedElelemnt from '../GeneratedElements/GeneratedElement1';
import { or } from 'react-native-reanimated';

const SCModal = ({ nombre, contenido }) => {

    const tailwind = useTailwind();
    const [isModalVisible, setModalVisible] = useState(false);

    const toggleModal = (number) => {
        console.log("activate view ",number)
        setModalVisible(!isModalVisible);
    };

    console.log("Contenido")
    console.log(contenido)

    return (
        <View style ={ tailwind("my-1") }>
            <TouchableOpacity  onPress={  toggleModal } style={ tailwind("text-xs bg-matconblue text-gray-800 p-4 m-2 px-14 rounded-md justify-center") } >
                <Text style={ tailwind("font-bold uppercase text-white text-center") }> { nombre["esp"] } </Text>
            </TouchableOpacity>
            <Modal 
                isVisible={ isModalVisible } 
                onBackdropPress={ toggleModal }
            >
                <View style={ [tailwind("text-xs bg-white  p-2 m-2 rounded-md justify-center"),{flex: 1}] } >
                    <Text font-bold> { nombre["esp"] } </Text>
                    <ScrollView style={ tailwind("bg-white p-4") }> 
                    {
                        contenido.map((subcontent, index) => {
                            return (
                                <GeneratedElelemnt
                                    tipo = { subcontent["tipo"] }
                                    align = { subcontent["align"] }
                                    firsttext = { subcontent["firsttext"] }
                                    ordered = { subcontent["ordered"] }
                                    initial = { subcontent["initial"] }
                                    text = { subcontent["text"] }
                                    listelements = { subcontent["listelements"] }
                                />
                            )
                        })
                    }
                    </ScrollView>
                    <TouchableOpacity  onPress={  toggleModal } style={ tailwind("text-xs bg-matconblue text-gray-800 p-4 m-2 px-14 rounded-md justify-center") } >
                        <Text style={ tailwind("font-bold uppercase text-white text-center") }> Ok </Text>
                    </TouchableOpacity>
                </View>
        </Modal>
        </View>
    )

}

export default SCModal